module.exports = __webpack_public_path__ + "static/media/08.d676f778.png";